/** Small time-zone helpers for the browser; mirrors the API's booking/time.ts. */

function offsetMs(ms: number, timeZone: string): number {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(new Date(ms));
  const get = (t: string) => Number(parts.find((p) => p.type === t)!.value);
  return (
    Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second")) -
    Math.floor(ms / 1000) * 1000
  );
}

/** The instant of `minuteOfDay` past local midnight of `date` (YYYY-MM-DD) in `timeZone`. */
export function zonedToUtc(date: string, minuteOfDay: number, timeZone: string): number {
  const [y, m, d] = date.split("-").map(Number);
  const wall = Date.UTC(y!, m! - 1, d!) + minuteOfDay * 60_000;
  const o1 = offsetMs(wall, timeZone);
  const u1 = wall - o1;
  if (offsetMs(u1, timeZone) === o1) return u1;
  const o2 = offsetMs(u1, timeZone);
  return wall - o2;
}

export const hhmmToMinutes = (s: string): number => {
  const [h, m] = s.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
};

export const minutesToHhmm = (minutes: number): string =>
  `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;

/** ISO instant for a date + HH:MM entered in the clinic's time zone. */
export function clinicDateTimeToIso(date: string, hhmm: string, timeZone: string): string {
  return new Date(zonedToUtc(date, hhmmToMinutes(hhmm), timeZone)).toISOString();
}
